<template>
  <div style="position: relative;">
    <div class="project-card" @click="goProjectItem(projectInfo.projectCode)">
        <div class="project-pic">
          <el-image
            style="width: 280px; height: 195px"
            :src="projectInfo.coverPicture"
            fit="cover"></el-image>
        </div>
       <div style="padding-left: 15px">
        <div class="project-con">
          <div class="con-left">
            <div class="project-tit">{{projectInfo.projectName}}</div>
          </div>
        </div>
        <div class="project-tip">
          <div class="tip-item" v-for="(tag, index) in projectInfoTags" :key="index">{{ tag }}</div>
        </div>
        <div v-if="cityId !== '3309'" div class="project-city">
          {{projectInfo.city}}{{'·'+projectInfo.district}}
        </div>
        <div class="project-price">
          {{ projectPrice }}{{ projectPriceUnit }}
          <div class="con-right">
            <div class="project-wx-code" @mouseover="mouseOver(projectInfo.projectCode)" @mouseleave="wxCodeShow = false">
              <img alt="二维码" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220528_1014162d4b804b314b4e4587e4624c30a84468.png">
              <transition name="el-zoom-in-top">
                <div class="wx-popu" v-show="wxCodeShow">
                  <img class="wx-img" alt="二维码" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220525_1657160a1961657b354b839a19c5c8363396a3.png">
                  <div class="wx-code">
                    <el-image
                      style="width: 150px; height: 150px"
                      :src="wxCode"
                      fit="cover">
                      <div style="margin-top: 25px;" slot="error" class="image-slot wx-code-loading">
                        <i class="el-icon-loading"></i>
                        <div class="text">加载中</div>
                      </div>
                    </el-image>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
       </div>
    </div>
    <div class="card-block" v-if="hasVr" @click="shapanDetail(projectInfo.resources[0])">
      <div class="card-image">
        <img
          class="card-section"
          alt="VR"
          src="https://xfjoss.coli688.com/pc-images/home-vr-arrow.png"
        />
        <span class="card-text">VR</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: "ProjectCard",
  props: {
    projectInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      wxCode: null,
      wxCodeShow: false,
      timer: null,
      tags: [],
      vrUrl: '',
    }
  },
  computed: {
    ...mapGetters([
      'homePage',
      'cityId'
    ]),
    projectPrice () {
      let {
        averagePrice, averagePriceUnit, displayPriceType,
        lowestTotalPrice, topTotalPrice, totalPriceUnit,
      } = this.projectInfo
      averagePrice = averagePrice || '--'
      lowestTotalPrice = lowestTotalPrice || '-'
      topTotalPrice = topTotalPrice || '-'
      const totalType = `${lowestTotalPrice}-${topTotalPrice}`
      const averageType = `${averagePrice}`
      if (displayPriceType === 2) {
        return totalPriceUnit && totalPriceUnit.indexOf('待定') !== -1 ? '价格待定': totalType
      } else {
        return averagePriceUnit && averagePriceUnit.indexOf('待定') !== -1 ? '价格待定': averageType
      }
    },
    projectPriceUnit () {
      let { averagePriceUnit,  totalPriceUnit, displayPriceType } = this.projectInfo
      averagePriceUnit = averagePriceUnit || '均价（元/平)'
      totalPriceUnit = totalPriceUnit || '万元/套'
      if (displayPriceType === 2) {
        return totalPriceUnit && totalPriceUnit.indexOf('待定') !== -1 ? '': totalPriceUnit
      } else {
        return averagePriceUnit && averagePriceUnit.indexOf('待定') !== -1 ? '': averagePriceUnit
      }
    },
    projectInfoTags () {
      return this.tags
    },
    hasVr () {
      const resources = this.projectInfo.resources[0] || {}
      const arr = ['rid', 'vrUrl', 'pcRid', 'vrUrlPc']
      const hasVr =  arr.some(item => resources[item])
      return hasVr
    }
  },
  watch: {
    'homePage.id' () {
      this.refreshTags()
    },
  },
  created () {
    this.refreshTags()
  },
  methods: {
     // 查看微沙盘
     shapanDetail (content) {
      const { rid, vrUrl, pcRid, vrUrlPc } = content
      if (vrUrlPc) {
        this.vrUrl = vrUrlPc
        this.$emit('shapanDetail', this.vrUrl, 'pc')
      } else if (pcRid) {
        axios.get(`https://xfj.coli688.com/super-gw/user-info/sand-box/shares/resources/${pcRid}`)
          .then(res=>{
            const url = res.data.data.wechat_shares.jump_url || ''
            const newUrl = url.replace(/_saas/, '')
            this.vrUrl = newUrl
            this.$emit('shapanDetail', this.vrUrl, 'pc')
          })
      } else if (vrUrl) {
        this.vrUrl = vrUrl
        this.$emit('shapanDetail', this.vrUrl, '')
      } else if (rid) {
        axios.get(`https://xfj.coli688.com/super-gw/user-info/sand-box/shares/resources/${rid}`)
        .then(res=>{
          const url = res.data.data.wechat_shares.jump_url || ''
          const newUrl = url.replace(/_saas/, '')
          this.vrUrl = newUrl
          this.$emit('shapanDetail', this.vrUrl, '')
        })
      }
    },
    refreshTags () {
      if(this.projectInfo.tags && this.projectInfo.tags.length >= 4) {
        this.tags = this.projectInfo.tags.slice(0,3)
      }else {
        this.tags = this.projectInfo.tags
      }
    },
    mouseOver(projectCode){
      this.wxCodeShow = true
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.wxCode) {
          return
        }
        this.getWxaCode(projectCode)
      }, 500);
    },
    // 生成小程序二维码
    getWxaCode(projectCode){
      const url = `pages/exhibitionHall/multiProject/detail?projectCode=${projectCode}`
      this.$api.getWxaCode(url).then(res => {
        const wxCode = res.data
        this.wxCode = wxCode
      })
    },
    // 跳转项目详情
    goProjectItem(projectCode){
      this.$router.push({ path: '/projectDetail', query:{projectCode} })
    }
  },

}
</script>
<style lang="scss" scoped>
@import "../home";
iframe {
  // position: fixed;
  z-index: 1001;
  // right: 0;
  // top: 0
}
</style>
